import { orderValidation } from "../order-validation";
import { showOrderValidation } from "../validation-feedback";
import { useTranslation as useInterfaceTranslation } from "react-i18next";
import { useState, useRef, useMemo } from "react";
import deleteIcon from "../../../assets/img/save_export/delete.svg";
import downloadIcon from "../../../assets/img/save_export/download.svg";
import printerIcon from "../../../assets/img/save_export/printer.svg";
import previewIcon from "../../../assets/img/save_export/preview.svg";
import shareIcon from "../../../assets/img/save_export/share.svg";
import error from "../../../assets/img/save_export/warning.svg";
import { useAppSelector, useAppDispatch } from "Redux/hooks";
import { useTranslation } from "react-i18next";
import { Overlay, Tooltip } from "react-bootstrap";
import toast from "react-hot-toast";
import { resolveSupplierPdfOrder } from "../../pdf-preview/order-details";
import { QuoteSnapshot } from "../../supplier-pricing/quote-document";
import { getCurrentOrderTools } from "Redux/middlwares/order";
import "./save-preview.scss";
import OrderTotals from "./order-totals";
import OrderPricingPanel from "../../supplier-pricing/order-pricing";

const ManageOrder = ({ ...props }: any) => {
  const { t: uiT } = useInterfaceTranslation("interface");
  const {
    setDeleteMessageShow,
    setSaveOrderMessageShow,
    setSaveBeforeShareShow,
    setSendToSupplierShow,
    errorText,
    setErrorText,
    openPdfPreview,
    setDownloadFlag,
    order,
    setOrder,
    activeProject,
    activeBusiness,
    isSupplier,
    summaryOnly = false,
    setPrintCanvas,
    edit,
    editOrderId,
    saveOrder,
    handleBidClicked,
    setOrderSaved,

  } = props;

  const dispatch = useAppDispatch();
  const { t } = useTranslation(["common", "newOrder"]);
  const userData = useAppSelector(state => state.user.userData);
  const [showDelTooltip, setShowDelTooltip] = useState(false);
  const [showPrevTooltip, setShowPrevTooltip] = useState(false);
  const [showPrintTooltip, setShowPrintTooltip] = useState(false);
  const [showDownTooltip, setShowDownTooltip] = useState(false);
  const [showShareTooltip, setShowShareTooltip] = useState(false);
  const targetDel = useRef(null);
  const targetPrev = useRef(null);
  const targetPrint = useRef(null);
  const targetDown = useRef(null);
  const targetShare = useRef(null);

  const rightToLeft = useAppSelector((state) => state.root.rightToLeft);
  const currentOrderRebars = useAppSelector(state => state.rebar.currentOrderRebars);
  const currentOrderNets = useAppSelector(state => state.net.currentOrderNets);
  const currentOrderPiles = useAppSelector(state => state.pile.currentOrderPiles);

  const [generatedQuote, setGeneratedQuote] = useState<QuoteSnapshot | null>(null);
  const [bidBtnClicked] = useState(true)
  const [disableSave, setDisableSave] = useState(false);

  const isExportOptionsDisabled = useMemo(() => {
    if (
      currentOrderRebars.length === 0 &&
      currentOrderNets.length === 0 &&
      currentOrderPiles.length === 0
    ) {
      return true;
    } else return false;
  }, [
    currentOrderRebars.length,
    currentOrderNets.length,
    currentOrderPiles.length,
  ]);

  const validate = () => {
    const issues = orderValidation(order, isSupplier, activeBusiness, activeProject,
      currentOrderNets.length + currentOrderPiles.length + currentOrderRebars.length);
    const messages = issues.map(key => t(key, { ns: "newOrder" }));
    setErrorText(messages.join(" · "));
    if (issues.length && window.matchMedia("(max-width: 991.98px)").matches) {
      showOrderValidation(messages, issues[0], rightToLeft);
    }
    return issues.length === 0;
  };

  const orderSave = (checkSaveOption:boolean) => {
    if (!validate()) return;

    if (checkSaveOption) {
      setDisableSave(true);
      saveOrder()
        .then(() => {
          setDisableSave(false);
          setOrderSaved(true);
        })
        .catch(() => {
          setDisableSave(false);
          setOrderSaved(false);
        });
    } else {
      setDisableSave(true);
      setErrorText("");

      saveOrder(true)
        .then(() => {
          setDisableSave(false);
        })
        .catch(() => {
          setDisableSave(false);
        });
    }
  };


  //function for calling order's note popup
  const getBid = (checkSaveOption:boolean) => {
    if (!validate()) return;

    if(checkSaveOption) {
      handleBidClicked(bidBtnClicked);
    }else{
      setSaveOrderMessageShow(true);
      setSaveBeforeShareShow(true);
    }
  };

  const exportDocument = async (mode: "preview" | "download" | "print", snapshot = generatedQuote) => {
    try {
      const result: any = await dispatch(getCurrentOrderTools(edit, editOrderId));
      const resolved = isSupplier ? await resolveSupplierPdfOrder({ ...(result || {}), ...order }, userData) : undefined;
      setDownloadFlag(mode === "download");
      setPrintCanvas(mode === "print");
      openPdfPreview(isSupplier ? snapshot || undefined : undefined, resolved ? { supplier_customer: resolved.supplier_customer, created_by: resolved.created_by } : undefined);
    } catch {
      setDownloadFlag(false); setPrintCanvas(false);
      toast.error(t("Error during PDF generation. Please try again."));
    }
  };
  const downloadPdf = () => exportDocument("download");
  const printCanvas = () => exportDocument("print");
  const previewPdf = () => exportDocument("preview");

  const shareOrder = () => {
    dispatch(getCurrentOrderTools(edit, editOrderId)).then(() => {
      orderSave(false);
    });
  }


  const openSupplierModal = () => {
    if (!validate()) return;

  setErrorText("");
  setSendToSupplierShow(true);
};

  return (
    <section id="order__summary" className="mb-5 mt-2">
      <div className="container p-0" style={{ display: "block" }}>
        <div className="error__wrapper">
          {errorText && (
            <div className="d-flex justify-content-center align-content-center">
              <img className="save_error_img" src={error} alt={"error"} />
              <p className="save__error">{errorText}</p>
            </div>
          )}
        </div>
        <OrderTotals
        rebars={currentOrderRebars}
        nets={currentOrderNets}
        piles={currentOrderPiles}
        />
        {isSupplier && (
          <OrderPricingPanel
            orderId={order?.order_id || editOrderId || null}
            supplierCustomerId={typeof order?.supplier_customer === "object" ? order?.supplier_customer?.id : order?.supplier_customer}
            priceList={order?.price_list || ""}
            onPriceListChange={(key) => setOrder((previous: any) => ({ ...previous, price_list: key }))}
            onSnapshotChange={setGeneratedQuote}
            onPreview={(snapshot) => { void exportDocument("preview", snapshot); }}
            draftItems={[...currentOrderRebars, ...currentOrderNets, ...currentOrderPiles]}
            business={activeBusiness}
          />
        )}
        {!summaryOnly && <div className="export__wrapper">
          <div className="text__area"></div>
          <div className="icon__area">
            <button
              className={
                "export__icons " +
                (rightToLeft ? "icons__right" : "icons__left")
              }
              onClick={() => setDeleteMessageShow(true)}
              ref={targetDel}
              onMouseEnter={() => setShowDelTooltip(true)}
              onMouseLeave={() => setShowDelTooltip(false)}
              disabled={isExportOptionsDisabled}
            >
              <img className="m__icon" src={deleteIcon} alt="delete icon" />
            </button>
            <Overlay
              target={targetDel.current}
              show={showDelTooltip}
              placement="top"
            >
              {(props) => (
                <Tooltip id="overlay-example-1" {...props}>
                  {t("Delete", { ns: "common" })}
                </Tooltip>
              )}
            </Overlay>
            <button
              className={
                "export__icons " +
                (rightToLeft ? "icons__right" : "icons__left")
              }
              onClick={previewPdf}
              ref={targetPrev}
              onMouseEnter={() => setShowPrevTooltip(true)}
              onMouseLeave={() => setShowPrevTooltip(false)}
              disabled={isExportOptionsDisabled}
            >
              <img className="m__icon" src={previewIcon} alt="preview icon" />
            </button>
            <Overlay
              target={targetPrev.current}
              show={showPrevTooltip}
              placement="top"
            >
              {(props) => (
                <Tooltip id="overlay-example-2" {...props}>
                  {t("Preview", { ns: "common" })}
                </Tooltip>
              )}
            </Overlay>
            <button
              className={
                "export__icons " +
                (rightToLeft ? "icons__right" : "icons__left")
              }
              ref={targetPrint}
              onMouseEnter={() => setShowPrintTooltip(true)}
              onMouseLeave={() => setShowPrintTooltip(false)}
              disabled={isExportOptionsDisabled}
              onClick={printCanvas}
            >
              <img className="m__icon" src={printerIcon} alt="printer icon" />
            </button>
            <Overlay
              target={targetPrint.current}
              show={showPrintTooltip}
              placement="top"
            >
              {(props) => (
                <Tooltip id="overlay-example-3" {...props}>
                  {t("Print", { ns: "common" })}
                </Tooltip>
              )}
            </Overlay>
            <button
              className={
                "export__icons " +
                (rightToLeft ? "icons__right" : "icons__left")
              }
              onClick={downloadPdf}
              ref={targetDown}
              onMouseEnter={() => setShowDownTooltip(true)}
              onMouseLeave={() => setShowDownTooltip(false)}
              disabled={isExportOptionsDisabled}
            >
              <img className="m__icon" src={downloadIcon} alt="download icon" />
            </button>
            <Overlay
              target={targetDown.current}
              show={showDownTooltip}
              placement="top"
            >
              {(props) => (
                <Tooltip id="overlay-example-4" {...props}>
                  {t("download", { ns: "common" })}
                </Tooltip>
              )}
            </Overlay>
            <button
              className={
                "export__icons " +
                (rightToLeft ? "icons__right" : "icons__left")
              }
              onClick={shareOrder}
              ref={targetShare}
              onMouseEnter={() => setShowShareTooltip(true)}
              onMouseLeave={() => setShowShareTooltip(false)}
              disabled={isExportOptionsDisabled}
            >
              <img className="m__icon" src={shareIcon} alt="share icon" />
            </button>
            <Overlay
              target={targetShare.current}
              show={showShareTooltip}
              placement="top"
            >
              {(props) => (
                <Tooltip id="overlay-example-4" {...props}>
                  {t("share", { ns: "common" })}
                </Tooltip>
              )}
            </Overlay>
            {/* <button
              className={rightToLeft ? "btn__left" : "bid__btn"}
              onClick={() => getBid(true)}
              disabled={isExportOptionsDisabled}
            >
              {t("Bid", { ns: "common" })}
            </button> */}
            <button
              type="button"
              className="send__supplier__btn text-center"
              onClick={openSupplierModal}
              disabled={isExportOptionsDisabled}
            > {uiT("Send to factory")} </button>
            <button
              className="save__btn text-center"
              onClick={() => orderSave(true)}
              disabled={isExportOptionsDisabled || disableSave}
            >
              {t("Save", { ns: "common" })}
            </button>
          </div>
        </div>}
      </div>
    </section>
  );
};

export default ManageOrder;
